import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TramDoService } from 'src/app/thmp-monitoring/services/tram-do.service';
import { latLng, LatLng, tileLayer, LayerGroup } from 'leaflet';
import * as L from "leaflet";
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { map, takeUntil } from 'rxjs';
import { ComponentBase } from 'sv-shared';

@Component({
  selector: 'app-mapview',
  templateUrl: './mapview.component.html',
  styleUrls: ['./mapview.component.css']
})
export class MapviewComponent extends ComponentBase implements OnInit {

  @ViewChild('mapRef', { static: true }) mapElement: ElementRef;
  dataSource = [];
  idStation = 0;

  idTramDo = 0;
  center = { lat: 17.438297, lng: 106.274805 };

  // map: L.Map;
  // markersLayer = new L.LayerGroup();
  // sMarkersLayer: LayerGroup;
  // zoomLevel = 9;
  // iconUrl = "https://decisionfarm.ca/assets/images/marker-icon-2x.png";

  options = {
    layers: [
      tileLayer('https://maps.vnpost.vn/api/tm/{z}/{x}/{y}.png?apikey=e44a53dfa985cc29e58fef98b6ec12e333809d605238f045', { maxZoom: 15, attribution: '...' })
    ],
    zoom: 6,
    center: [17.438297, 106.274805]
  };

  constructor(
    private _tramDoService: TramDoService,
    private _datepipe: DatePipe,
    protected _activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  async ngOnInit() {

    this._activatedRoute.params
      .pipe(map(params => params['id']), takeUntil(this._unsubscribeAll))
      .subscribe(async pid => {
        this.idTramDo = pid;
        console.log(pid);
      });

    await this.getData();
    await this.renderMap();
  }

  async getData() {
    await this._tramDoService.getsAllByUser().then((res) => {
      if (res.success) {
        this.dataSource = res.data;
        if (this.idTramDo != 0) {
          var itemTramDo = this.dataSource.find(x => x.tramDoInfo.id == this.idTramDo);
          if (itemTramDo != undefined && itemTramDo != null && itemTramDo.tramDoInfo.gpsLat != null && itemTramDo.tramDoInfo.gpsLong != null) {
            this.center = { lat: parseFloat(itemTramDo.tramDoInfo.gpsLat), lng: parseFloat(itemTramDo.tramDoInfo.gpsLong) };
          }
        }
      }
    });
  }

  loadMap = () => {
    this.mapElement.nativeElement.innerHTML = "";
    const map = new window['google'].maps.Map(this.mapElement.nativeElement, {
      //center: { lat: 17.438297, lng: 106.274805 },
      center: this.center,
      zoom: 6,
      mapId: 'demo-map'
    });

    this.dataSource.forEach(async element => {
      if (element.tramDoInfo.gpsLat !== null && element.tramDoInfo.gpsLong !== undefined) {
        // var sensors = []
        // await this._measurementValuesService.getMapViewByIdMeasurementStation(element.id).then(rs => {
        //   if (rs.success) {
        //     sensors = rs.data;
        //     element.idTinhTrangHoatDong = rs.data[0].tinhTrangHoatDongDuLieuTram;
        //   }
        // });
        // console.log(position);
        var trangThaiHoatDong = element.tramDoInfo.trangThaiHoatDong != 1 ? element.tramDoInfo.trangThaiHoatDong : element.tramDoInfo.trangThaiHoatDongData;
        const marker = new window['google'].maps.Marker({
          position: { lat: parseFloat(element.tramDoInfo.gpsLat), lng: parseFloat(element.tramDoInfo.gpsLong) },
          map: map,
          title: element.tramDoInfo.title,
          icon: `/assets/images/kttv/mapicon${trangThaiHoatDong}.png`,
        });

        var popupStr = `<div style="height:100%;width:200px;">
                <table style="width:100%">
                <thead>
                    <tr>
                        <th style='font-weight:bold; height:25px; padding-left:5px'>
                            Tên trạm: ${element.tramDoInfo.title}
                        </th>
                    </tr>
                </thead>
                <tbody>`;
        if (element.dmYeuToDoDtos !== undefined) {
          element.dmYeuToDoDtos.forEach(itemSensor => {
            popupStr += `
                        <tr>
                            <td style='height:25px;'>
                                <span style='margin-top: 5px; width: 100%; display: flex; padding-left:5px'>
                                ${itemSensor.title} (${itemSensor.donViDo}): ${itemSensor.giaTri}</pan>
                            </td>
                        </tr>
                        `;
          });
        }

        popupStr += `
          <tr>
            <td style='height:25px;'>
              <span style='margin-top: 5px; width: 100%; display: flex; padding-left:5px'>
                Thời gian đo: ${this._datepipe.transform(element.tramDoInfo.modified, 'HH:mm - dd/MM/yyyy')}</pan>
            </td>
          </tr>
          <tr>
            <td style='height:25px;'>
              <span style='margin-top: 5px; width: 100%; display: flex; padding-left:5px'>
                Trạng thái: ${this.getTrangThaiHoatDong(element.tramDoInfo)}</pan>
            </td>
          </tr>`;

        popupStr += `
            <tr>
                <td style='height:25px;'>
                    <span style='margin-top: 5px; width: 100%; display: flex; padding-left:5px'>
                    <a href='/bieudo/${element.tramDoInfo.id}'>Xem chi tiết</a></pan>
                </td>
            </tr>
                </tbody>
                </table> `;

        var infowindow = new window['google'].maps.InfoWindow({
          content: popupStr
        });

        marker.addListener('click', function () {
          infowindow.open(map, marker);
        });
        if (element.id == this.idStation) {
          infowindow.open(map, marker);
        }
      }
    });
  }
  getTrangThaiHoatDong(tramDoInfo: { trangThaiHoatDong: number, trangThaiHoatDongData: number }) {
    switch (tramDoInfo.trangThaiHoatDong) {
      case 1:
        switch (tramDoInfo.trangThaiHoatDongData) {
          case 2:
            return 'Đang đo';
          case 3:
            return 'Hiệu chuẩn';
          case 4:
            return 'Kiểm tra';
          default:
            return '';
        }
      case 2:
        return 'Đang đo';
      case 3:
        return 'Hiệu chuẩn';
      case 4:
        return 'Kiểm tra';
      default:
        return '';
    }
  }

  async renderMap() {
    window['initMap'] = () => {
      this.loadMap();
    }
    if (!window.document.getElementById('google-map-script')) {
      var s = window.document.createElement("script");
      s.id = "google-map-script";
      s.type = "text/javascript";
      s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyC89aP5P3qvEbBSOHtTISq0RZKdZDpjIhA&signed_in=true&callback=initMap&libraries=marker";

      window.document.body.appendChild(s);
    } else {
      this.loadMap();
    }
  }

  // addLeafletMarker() {
  //   this.sMarkersLayer = new L.LayerGroup();
  //   this.dataSource.forEach(element => {
  //     console.log(element);
  //     let icon = new L.DivIcon({
  //       html: `<img src='${this.iconUrl}'/> <span>${element.title}</span>`
  //     });
  //     const marker = L.marker([element.tramDoInfo.gpsLat, element.tramDoInfo.gpsLong], {
  //       icon: L.icon({
  //         iconUrl: this.iconUrl,
  //         iconSize: [25, 41],
  //         iconAnchor: [13, 41],
  //         popupAnchor: [0, -41],
  //       })
  //     });
  //     marker.on('click', () => {
  //       marker.bindPopup(`<b>${element.tramDoInfo.title}</b><br>${element.tramDoInfo.gpsLat}, ${element.tramDoInfo.gpsLong}`).openPopup();
  //     });
  //     this.sMarkersLayer.addLayer(marker);
  //     // if (element.tramDoInfo.gpsLat !== null && element.tramDoInfo.gpsLong !== undefined) {
  //     //   var marker = L.marker([element.tramDoInfo.gpsLat, element.tramDoInfo.gpsLong], {
  //     //     icon: L.icon({
  //     //       iconUrl: this.iconUrl,
  //     //       iconSize: [25, 41],
  //     //       iconAnchor: [13, 41],
  //     //       popupAnchor: [0, -41],
  //     //     })
  //     //   }).bindPopup(`<b>${element.tramDoInfo.title}</b><br>${element.tramDoInfo.gpsLat}, ${element.tramDoInfo.gpsLong}`);
  //     //   this.sMarkersLayer.addLayer(marker);
  //     // }
  //   });
  //   this.markersLayer.addLayer(this.sMarkersLayer);
  // }
  // onMapReady(map: L.Map) {
  //   setTimeout(() => {
  //     map.invalidateSize();
  //     this.map = map;
  //     map.addLayer(this.markersLayer);
  //     this.addLeafletMarker();
  //   }, 200);
  // }

}
